import React from "react";
import { TransactionActivityLogEvent } from "../../types";

interface TransactionActivityLogCardProps {
  events?: TransactionActivityLogEvent[];
}

export const TransactionActivityLogCard: React.FC<TransactionActivityLogCardProps> = ({
  events = [],
}) => {
  if (!events || events.length === 0) {
    return (
      <div className="flex h-full min-h-[140px] flex-col items-center justify-center rounded-2xl border border-[#EEF1FB] bg-white p-6 shadow-sm text-center">
        <p className="text-[13px] font-medium text-[#667085]">No activity logged yet.</p>
      </div>
    );
  }
  return (
    <div className="flex h-full flex-col rounded-2xl border border-[#EEF1FB] bg-white p-6 shadow-sm">
      <div className="relative space-y-6 before:absolute before:left-[3px] before:top-2 before:h-[calc(100%-16px)] before:w-px before:bg-[#E4E7F4]">
        {events.map((event) => {
          const isFinalInitiatedWithoutActor = !event.actorName;

          return (
            <div key={event.id} className="relative pl-6">
              <span className="absolute left-0 top-1.5 z-10 h-2 w-2 rounded-full bg-[#D0D5DD] ring-4 ring-white" />

              {isFinalInitiatedWithoutActor ? (
                <div className="flex flex-col gap-0.5">
                  <span className="text-[13px] font-semibold text-[#101828]">
                    {event.boldTarget}
                  </span>
                  <span className="text-[11px] text-[#667085]">
                    {event.timestamp}
                  </span>
                </div>
              ) : (
                <div className="flex flex-col gap-1">
                  <span className="text-[11px] text-[#667085]">
                    {event.timestamp}
                  </span>

                  <div className="flex items-center gap-2 text-[13px] text-[#344054]">
                    <div
                      className={`flex h-4 w-4 shrink-0 items-center justify-center rounded-full text-[9px] font-bold ${
                        event.isCustomer
                          ? "bg-[#D1E9FF] text-[#175CD3]"
                          : "bg-[#F4EBFF] text-[#6F00FF]"
                      }`}
                    >
                      {event.actorName ? event.actorName.slice(0, 1).toUpperCase() : "M"}
                    </div>

                    <span>
                      <span className="font-medium text-[#101828]">
                        {event.actorName}
                      </span>{" "}
                      {event.actionPrefix ? `${event.actionPrefix} ` : ""}
                      <strong className="font-semibold text-[#101828]">
                        {event.boldTarget}
                      </strong>
                      {event.actionSuffix ? ` ${event.actionSuffix}` : ""}
                    </span>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
